
import { Options, Vue } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IFlexAnswer } from '@/utils/types'
import FlexMessageModal from '@/components/common/flex-message/FlexMessageModal.vue'

@Options({
  components: { FlexMessageModal },
  directives: { maska },
  emits: ['update:modelValue'],
})
export default class FlexSelector extends Vue {
  @Prop()
  modelValue!: IFlexAnswer

  flexModalVisible = false

  get value() {
    return this.modelValue
  }

  set value(value: IFlexAnswer) {
    this.$emit('update:modelValue', value)
  }

  updateData(value: IFlexAnswer) {
    this.value = value
  }

  onCloseModal() {
    this.flexModalVisible = false
  }
}
